import { Province } from "../../types";

export enum PREFECTURES_ACTIONS {
  PREFECTURES_LIST = "PREFECTURES_LIST",
  PREFECTURES_ERROR = "PREFECTURES_ERROR",
  PREFECTURES_MODAL = "PREFECTURES_MODAL",
  PREFECTURES_LOADING = "PREFECTURES_LOADING",
  PREFECTURES_MUTATION_LOADING = "PREFECTURES_MUTATION_LOADING",
}

export interface PrefecturesState {
  prefectures: Province[];
  showModal: boolean;
  isLoading: boolean;
  isMutationLoading: boolean;
  error: { [x: string]: string } | string | null;
}

const initialState: PrefecturesState = {
  prefectures: [],
  showModal: false,
  isLoading: false,
  isMutationLoading: false,
  error: null,
};

export interface PrefecturesActionType {
  type: keyof typeof PREFECTURES_ACTIONS;
  payload: any;
}

const reducer = (
  state: PrefecturesState = initialState,
  action: PrefecturesActionType
): PrefecturesState => {
  switch (action.type) {
    case PREFECTURES_ACTIONS.PREFECTURES_LIST:
      return {
        ...state,
        prefectures: action.payload,
        isLoading: false,
      };

    case PREFECTURES_ACTIONS.PREFECTURES_ERROR:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };

    case PREFECTURES_ACTIONS.PREFECTURES_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };

    case PREFECTURES_ACTIONS.PREFECTURES_MODAL:
      return {
        ...state,
        showModal: action.payload,
      };

    case PREFECTURES_ACTIONS.PREFECTURES_MUTATION_LOADING:
      return {
        ...state,
        isMutationLoading: action.payload,
      };

    default:
      return {
        ...state,
      };
  }
};

export default reducer;


